export const SET_STATE = 'hotelPageMonthlyPrice/SET_STATE';
export const SET_FETCHING = 'hotelPageMonthlyPrice/SET_FETCHING';
export const SET_MONTHLY_PRICES_VALUE = 'hotelPageMonthlyPrice/SET_MONTHLY_PRICES_VALUE';
export const RESET_STATE = 'hotelPageMonthlyPrice/RESET_STATE';
